webpackJsonp([21],{

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-about-lazy-img").lazy({
    bind: 'event',
    effect: 'fadeIn',
    effectTime: 500,
    threshold: 0
  });
});

/***/ })

},[316]);


// WEBPACK FOOTER //
// dist/about.js